module.exports = __webpack_public_path__ + "static/media/loading.18be94cf.gif";